/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 15:15:10 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

// GLOSSARY of permissions
//
// const advertDisabled = 'advert.disabled'; //Enabling this will prevent the presentation of advertisements within the app - not used in cms
const subcontractorInvite = 'subcontractor.invite'; //Enabling this will allow the presentation of the subcontractor tab within organisations.
const towerPlanTower = 'tower.planTower'; //Enabling this will allow the presentation of the planned towers tab within organisations.
const inspectionToggleChecklist = 'inspection.toggleChecklist'; //Enabling this will allow the organisation to adjust whether their builders must view the checklist during an inspection
// const towerInspectionTag = 'tower.inspectionTag'; //Enabling this will allow the organisation to use the inspection record label during the creation of a tower - not used in cms
// const inspectionExportCSV = 'inspection.exportCSV'; //Enabling this will allow the organisation to export the inspection data csv - can't really use this as inspections have multiple orgs
const inspectionExportPDF = 'inspection.exportPDF'; //Enabling this will allow the organisation to download the inspection label PDF
// const dashboardExtended = 'dashboard.extended'; //TODO: awaiting feedback from client on what this is
const checklistTypesExtended = 'checklistTypes.extended'; // Enable to select additional checklist types for project

const checkIsAllowed = (capabilities, permission) => {
  if (capabilities && capabilities.length > 0) {
    return capabilities.some(
      capability => capability.id === permission && capability.enabled
    );
  }
  return false;
};

export const isInviteSubcontractorAllowed = capabilities =>
  checkIsAllowed(capabilities, subcontractorInvite);

export const isPlanTowerAllowed = capabilities =>
  checkIsAllowed(capabilities, towerPlanTower);

export const isChecklistAllowed = capabilities =>
  checkIsAllowed(capabilities, inspectionToggleChecklist);

export const isExportPDFAllowed = capabilities =>
  checkIsAllowed(capabilities, inspectionExportPDF);

export const areChecklistTypesExtended = capabilities =>
  checkIsAllowed(capabilities, checklistTypesExtended);
